import BasicDateInput from "components/BasicInputs/BasicDateInput";
import Table from "components/Table";
import { indexData } from "forms";
import useDateState from "helpers/useDateState";
import DateFilterHeader from "./DateHeaderFilter";
import FilterAccountReview from "./FilterAccountReview";
import { checkUserAccess } from "helpers/helper";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { store } from "store/store";

const DateFilter = () => {
    const path = window.location.href
    return (
        <>
            <DateFilterHeader type={path.includes("gardesh") ? "gardesh" : "reviewAccount"} />
            {
                !path.includes("gardesh") &&
                    <FilterAccountReview type={path.includes("gardesh") ? "gardesh" : "reviewAccount"} />
            }
        </>

    )
}

export default function ReviewAccounts({ type }: { type: string }) {
    const { getState } = store
    //@ts-ignore
    const selectedIds = getState().selectBoxTableValueReducer?.selectedIds

    if (type === "gardesh") {
        return (
            <div className="warp-capital">
                <Table type="gardesh" pagination={false} MidComponent={DateFilter as any} />
            </div>
        )
    }
    return (
        <div className="warp-capital">
            <Table type="reviewAccount" pagination={false} middleComp={<DateFilter />} />
        </div>
    )
}
